export const PARTNER_TIER_DESC = 'PARTNER_TIER_DESC';
export const NEWEST = 'NEWEST';
export const NAME_A_Z = 'NAME_A_Z';
export const NAME_Z_A = 'NAME_Z_A';
export const RELEVANCE_DESC = 'RELEVANCE_DESC';

// Not a primary sort options, only ever used as a secondary sort
export const PARTNER_TYPE_ASC = 'PARTNER_TYPE_ASC';
export const REVIEW_COUNT_DESC = 'REVIEW_COUNT_DESC';
export const OLDEST = 'OLDEST';